'use client'

import { createContext, useCallback, useContext, useState, type ReactNode } from 'react'
import { LoginModal } from '@/app/landing/LoginModal'

type LoginModalContextValue = {
  openLoginModal: (_redirect?: string, _source?: string, options?: { required?: boolean }) => void
}

const LoginModalContext = createContext<LoginModalContextValue | null>(null)

export function LoginModalProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false)
  const [required, setRequired] = useState(false)

  const openLoginModal = useCallback((_redirect?: string, _source?: string, options?: { required?: boolean }) => {
    setRequired(options?.required ?? false)
    setOpen(true)
  }, [])

  const closeLoginModal = useCallback(() => {
    setOpen(false)
    setRequired(false)
  }, [])

  return (
    <LoginModalContext.Provider value={{ openLoginModal }}>
      {children}
      <LoginModal open={open} onClose={closeLoginModal} required={required} />
    </LoginModalContext.Provider>
  )
}

export function useLoginModal() {
  const ctx = useContext(LoginModalContext)
  if (!ctx) {
    throw new Error('useLoginModal must be used within LoginModalProvider')
  }
  return ctx
}
